import { PureComponent, ReactNode } from 'react';

import { FormattedMessage } from 'react-intl';

import File from '../../containers/file-filter-list-item';
import { TreeEntry } from '../../types';
import directoryMessages from '../directory.i18n';
import { ListFooter } from '../directory.style';

import messages from './i18n';

type Props = {
  files: TreeEntry[];
  maxLength?: number;
};

export default class FilteredFileList extends PureComponent<Props> {
  render(): ReactNode {
    const { files, maxLength } = this.props;

    return (
      <div>
        <table>
          <thead>
            <tr>
              <th colSpan={2}>
                <FormattedMessage {...directoryMessages.columnHeaderName} />
              </th>
            </tr>
          </thead>
          <tbody>
            {files.slice(0, maxLength).map(file => (
              <File file={file} key={file.name} />
            ))}
          </tbody>
        </table>

        {maxLength && files.length > maxLength && (
          <ListFooter>
            <FormattedMessage
              {...messages.moreFilesFound}
              values={{ count: maxLength }}
            />
          </ListFooter>
        )}
      </div>
    );
  }
}
